import { FunctionComponent } from 'react';
import styled from 'styled-components';
import { DashboardWrapper, Card, Text } from 'src/shared';
import { Colors } from 'src/utils/color';
import { Size } from 'src/shared/text';
import { UserSelectors } from 'src/reducers/user';

const Container = styled.div`
    display: flex;
    flex-direction: column;
    gap: 20px;
    padding: 24px;
    max-width: 720px;
`;

const SectionCard = styled(Card)`
    padding: 20px;
`;

const SectionTitle = styled.div`
    font-size: 14px;
    font-weight: 600;
    color: ${Colors.extra.black};
    margin-bottom: 16px;
`;

const Row = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 10px 0;
    border-bottom: 1px solid ${Colors.extra.light_gray};
    &:last-child { border-bottom: none; }
`;

const Label = styled.span`
    font-size: 13px;
    color: ${Colors.extra.dark_gray};
`;

const Value = styled.span`
    font-size: 13px;
    font-weight: 500;
    color: ${Colors.extra.black};
`;

const VersionTag = styled.span`
    font-size: 11px;
    color: ${Colors.extra.dark_gray};
    padding: 4px 8px;
    border-radius: 4px;
    background: ${Colors.extra.light_gray};
`;

const SettingsPage: FunctionComponent = () => {
    const { profile } = UserSelectors();

    const fullName = profile?.first_name && profile?.last_name
        ? `${profile.first_name} ${profile.last_name}`
        : profile?.username || '—';

    return (
        <DashboardWrapper>
            <Container>
                <div>
                    <Text fontSize={Size.Large} fontWeight="600" color={Colors.extra.black}>
                        Settings
                    </Text>
                    <Text fontSize={Size.Small} color={Colors.extra.dark_gray} marginTop={8}>
                        Account, organization, and preferences
                    </Text>
                </div>

                <SectionCard>
                    <SectionTitle>Account</SectionTitle>
                    <Row>
                        <Label>Name</Label>
                        <Value>{fullName}</Value>
                    </Row>
                    <Row>
                        <Label>Email</Label>
                        <Value>{profile?.email || '—'}</Value>
                    </Row>
                    <Row>
                        <Label>Username</Label>
                        <Value>{profile?.username || '—'}</Value>
                    </Row>
                </SectionCard>

                <SectionCard>
                    <SectionTitle>Organization</SectionTitle>
                    <Row>
                        <Label>Group</Label>
                        <Value>{profile?.group_name || (profile?.group_id ? `Group ${profile.group_id}` : '—')}</Value>
                    </Row>
                    <Row>
                        <Label>Group ID</Label>
                        <Value>{profile?.group_id ?? '—'}</Value>
                    </Row>
                </SectionCard>

                <SectionCard>
                    <SectionTitle>Preferences</SectionTitle>
                    <Row>
                        <Label>Theme</Label>
                        <Value>{localStorage.getItem('darkMode') === 'true' ? 'Dark' : 'Light'}</Value>
                    </Row>
                    <Row>
                        <Label>Sidebar</Label>
                        <Value>{localStorage.getItem('sidebarOpen') !== 'false' ? 'Expanded' : 'Collapsed'}</Value>
                    </Row>
                </SectionCard>

                <SectionCard>
                    <SectionTitle>About</SectionTitle>
                    <Row>
                        <Label>Platform</Label>
                        <Value>RetiOne Clinical Platform</Value>
                    </Row>
                    <Row>
                        <Label>Version</Label>
                        <VersionTag>1.0.0</VersionTag>
                    </Row>
                    <Row>
                        <Label>Support</Label>
                        <Value>engineering@clighttechnologies.com</Value>
                    </Row>
                </SectionCard>
            </Container>
        </DashboardWrapper>
    );
};

export default SettingsPage;
